import type { EmbedBlock as EmbedBlockType } from "@/types";
import { parseEmbed } from "../embed";

/** Sandboxed video embed (§5B). The URL is provider-parsed into a known-good
 *  src; unknown providers render an inline notice, never raw HTML. */
export function EmbedBlock({ block }: { block: EmbedBlockType }) {
  const { url, caption } = block.props;
  const parsed = parseEmbed(url);

  if (!parsed) {
    return (
      <section className="block block--embed">
        <p className="block--embed__unsupported">
          Unsupported video link. Paste a YouTube or Vimeo URL.
        </p>
      </section>
    );
  }

  return (
    <figure className="block block--embed">
      <div className="block--embed__frame">
        <iframe
          src={parsed.src}
          title={parsed.title}
          loading="lazy"
          sandbox="allow-scripts allow-same-origin allow-presentation allow-popups"
          allow="fullscreen; encrypted-media; picture-in-picture"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        />
      </div>
      {caption ? <figcaption className="block--embed__caption">{caption}</figcaption> : null}
    </figure>
  );
}
